// Copyright 2023, Alexander Nekrasov, All rights reserved.

import { getMessages } from "../code/global";

export default {
  install(app /*, options*/) {
    if (app.config?.globalProperties) {
      //console.log("Vue3");
      app.config.globalProperties.$messages = getMessages();
    } else if (app.prototype) {
      //console.log("Vue2");
      app.prototype.$messages = getMessages();
    }
  },
};
